import { VaultList } from "../../constants/constants";
export var ProductList = [
    "yield",
    "volatility",
    "principalProtection",
    "capitalAccumulation",
];
export var VaultStrategyList = ["COVERED-CALL", "PUT-SELLING"];
export var VaultSortByList = [
    "SORT BY",
    "NEWEST FIRST",
    "OLDEST FIRST",
    "YIELD: HIGH TO LOW",
    "YIELD: LOW TO HIGH",
];
export var VaultSortByFilterOptions = VaultSortByList.map(function (item) {
    return item === VaultSortByList[0]
        ? {
            display: "DEFAULT",
            value: item,
        }
        : item;
});
export var VaultReleaseOrder = VaultList;
//# sourceMappingURL=types.js.map